module.exports = __webpack_public_path__ + "img/banner.da13a66f.png";